import { Country } from './config';

const EN_MESSAGE = {
  strong: "We're upgrading our support channels.",
  weak: 'Chat and calls are temporarily unavailable. For assistance please open a request or email',
};
export const SPORTYBET_MAINTENANCE_MESSAGES: Required<
  Record<Country, { message: Record<string, { strong: string; weak: string }>; email: string }>
> = {
  [Country.NG]: {
    message: {
      en: EN_MESSAGE,
    },
    email: 'nigeria.support@sportybet.com',
  },
  [Country.GH]: {
    message: {
      en: EN_MESSAGE,
    },
    email: 'ghana.support@sportybet.com',
  },
  [Country.KE]: {
    message: {
      en: EN_MESSAGE,
      sw: {
        strong: 'Tunaboresha majukwaa yetu ya usaidizi.',
        weak: ' Gumzo na simu hazipatikani kwa sasa. Kwa usaidizi tafadhali tumia huduma ya Ombi au Barua Pepe kupitia anwani',
      },
    },
    email: 'kenya.support@sportybet.com',
  },
  [Country.UG]: {
    message: {
      en: EN_MESSAGE,
    },
    email: 'uganda.support@sportybet.com',
  },
  [Country.ZM]: {
    message: {
      en: EN_MESSAGE,
    },
    email: 'zambia.support@sportybet.com',
  },
  [Country.TZ]: {
    message: {
      en: EN_MESSAGE,
      sw: {
        strong: 'Tunafanya maboresho ya huduma kwenye njia zetu za mawasiliano.',
        weak: 'Huduma za Chat na Simu hazipatikani kwa sasa. Kwa msaada zaidi tafadhali fungua ombi au tuma barua pepe',
      },
    },
    email: 'tanzania.support@sportybet.com',
  },
  // unused.
  [Country.INT]: {
    message: {
      en: EN_MESSAGE,
    },
    email: 'international.support@sportybet.com',
  },
  [Country.CM]: {
    message: {
      en: EN_MESSAGE,
      fr: {
        strong: "Nous mettons à jour nos canaux d'assistance.",
        weak: "Le chat et les appels sont temporairement indisponibles. Pour obtenir de l'aide, veuillez créer une demande ou nous envoyer un e-mail à",
      },
      'fr-cm': {
        strong: "Nous mettons à jour nos canaux d'assistance.",
        weak: "Le chat et les appels sont temporairement indisponibles. Pour obtenir de l'aide, veuillez créer une demande ou nous envoyer un e-mail à",
      },
    },
    email: 'cameroon.support@sportybet.com',
  },
  [Country.ZA]: {
    message: {
      en: {
        strong:
          'Dear Valued SportyBet Users. Please note - We are currently updating our support channels. Chat and phone support will be temporarily unavailable.',
        weak: ' For assistance, please create a support request or email us at ',
      },
    },
    email: 'support@sportybet.co.za.',
  },
  [Country.BR]: {
    message: {
      en: EN_MESSAGE,
      pt: {
        strong: 'Estamos atualizando nossos canais de atendimento.',
        weak: 'No momento, o chat e as chamadas estão temporariamente indisponíveis.Para receber suporte, entre em contato pelo e-mail',
      },
    },
    email: 'suporte@sporty.bet.br',
  },
  [Country.MX]: {
    message: {
      en: EN_MESSAGE,
      'es-mx': {
        strong: 'Estamos actualizando nuestros canales de asistencia.',
        weak: 'El chat y las llamadas no estarán disponibles temporalmente. Si necesita ayuda, envíe una solicitud o envíe un correo electrónico a ',
      },
    },
    email: 'soporte@sportybet.mx',
  },
  [Country.MZ]: {
    message: {
      en: EN_MESSAGE,
      'pt-mz': {
        strong: 'Estamos a atualizar os nossos canais de atendimento.',
        weak: 'De momento, o chat e as chamadas estão temporariamente indisponíveis. Para obter suporte, entre em contacto por e-mail',
      },
    },
    email: 'mocambique.suporte@sportybet.com',
  },
};

export const FOOTBALL_COM_MAINTENANCE_MESSAGES: Partial<
  Record<Country, { message: Record<string, { strong: string; weak: string }>; email: string }>
> = {
  [Country.NG]: {
    message: {
      en: EN_MESSAGE,
    },
    email: 'nigeria.support@football.com',
  },
  [Country.GH]: {
    message: {
      en: EN_MESSAGE,
    },
    email: 'ghana.support@football.com',
  },
};

export function getMaintenanceMessageFromConfig(
  country: Country,
  language: string,
  factory: Partial<
    Record<
      Country,
      {
        message: Record<
          string,
          {
            strong: string;
            weak: string;
          }
        >;
        email: string;
      }
    >
  >
): { strong: string; weak: string; email: string } | null {
  const config = factory[country];
  if (!config) return null;

  const message = config.message[`${language}`.toLocaleLowerCase()] || config.message.en;
  if (!message) return null;

  return {
    strong: message.strong,
    weak: message.weak,
    email: config.email,
  };
}
